'use client';

import { DisplayOnMountedAdSlot } from '@fe-news/components/atoms/AdSlot';
import LoadingSkeleton from '@fe-common-ui/LoadingSkeleton';
import LazyLoadComponent from '@fe-news/components/LazyLoadComponent/LazyLoadComponent';
import MobileAdProfiles from '@fe-news/constants/DFP/MobileAdProfiles';
import dynamic from 'next/dynamic';
import AsidePopTopicSkeleton from '@fe-news/components/molecules/AsidePopTopic/AsidePopTopicSkeleton';
import AsideAiNews from '@fe-news/components/molecules/AsideAiNews';

const NewsPopular = dynamic(() => import('@fe-news/components/molecules/AsideNewsPopular/AsideNewsPopular'), {
  loading: () => <LoadingSkeleton.NewsPopularSkeleton />,
  ssr: false
});

const AsidePopTopic = dynamic(() => import('@fe-news/components/molecules/AsidePopTopic'), {
  loading: () => <AsidePopTopicSkeleton />,
  ssr: false
});

const AigcAsideMobile = () => {
  return (
    <>
      {/* AI讀新聞 */}
      <AsideAiNews isAiGc />
      {/* 人氣排行 */}
      <LazyLoadComponent PlaceholderComponent={<LoadingSkeleton.NewsPopularSkeleton />} id='NewsPopular'>
        <NewsPopular />
      </LazyLoadComponent>
      <DisplayOnMountedAdSlot profile={MobileAdProfiles.AigcCnyesAiMiddle} />
      {/* 熱門時事 */}
      <LazyLoadComponent id='PopTopic' exposureRate={0.1} PlaceholderComponent={<AsidePopTopicSkeleton />}>
        <AsidePopTopic />
      </LazyLoadComponent>
    </>
  );
};

export default AigcAsideMobile;
